import apiClient from "@shared/config/axiosConfig";

const configuracionService = {
  getConfiguracion: async (idusuario) => {
    const response = await apiClient.get(`/configuracion/${idusuario}`);
    return response.data;
  },

  updateConfiguracion: async (idusuario, data) => {
    const response = await apiClient.put(`/configuracion/${idusuario}`, data);
    return response.data;
  },
};

export default configuracionService;
